<template>
  <el-dialog title="申请出库" :visible.sync="dialogVisible" width="70%">
    <el-row class="custom-container">
      <el-col :span="4">
        <el-image
            v-if="infoData.imagesList !=null"
            style="width: 100%; height: 100%;"
            :src="infoData.imagesList[0]"
            :preview-src-list="infoData.imagesList"
        ></el-image>
        <div v-else>
            暂无图片
        </div>
      </el-col>
      <el-col :span="18" :offset="2">
        <div class="inform flex">
          <div class="title">库存编号：</div>
          <div>{{ infoData.inventoryNumber }}</div>
        </div>
        <div class="inform flex">
          <div class="title">公司：</div>
          <div>{{ infoData.branchCompanyName }}</div>
        </div>
        <div class="inform flex">
          <div class="title">全称：</div>
          <div>{{ infoData.productFullName }}</div>
        </div>
        <div class="inform flex">
          <div class="title">简称：</div>
          <div>{{ infoData.productSimpleName }}</div>
        </div>
        <div class="inform flex">
          <div class="title">描述：</div>
          <div>{{ infoData.productDescription }}</div>
        </div>
        <el-row type="flex" justify="space-between">
          <div class="inform flex">
            <div class="title">即时库存数量：</div>
            <div>{{ infoData.actualCount }}</div>
          </div>
          <el-button type="primary" @click="BarCode">条线码打印</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row class="custom-container" v-for="(item,index) in infoData.productInfos" :key="index">
      <el-col :span="4">
        <el-image
            style="width: 100%; height: 100%;"
            :src="item.imageUrl"
            :preview-src-list="[item.imageUrl]"
        ></el-image>
      </el-col>
      <el-col :span="18" :offset="2">
        <div class="inform flex">
          <div class="title">亚马逊订单号：</div>
          <div>{{ infoData.amazonOrderId }}</div>
        </div>
        <div class="inform flex">
          <div class="title">标题：</div>
          <div>{{ item.title }}</div>
        </div>
        <div class="inform flex">
          <div class="title">SKU：</div>
          <div>{{ item.sku }}</div>
        </div>
        <div class="inform flex">
          <div class="title">数量：</div>
          <div>{{ item.quantityOrdered }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" style="margin-top: 20px;">
      <el-col :span="6">申请数量：{{ bottomData.useCount }}</el-col>
      <el-col :span="6">仓库名称：{{ bottomData.warehouseName }}</el-col>
      <el-col :span="6">货架：{{ bottomData.shelfNumber }}</el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmOutWarehouse" :loading="isDoneBtnLoding">确认出库</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  name: "ApplicationForWarehouse",

  data() {
    return {
      dialogVisible: false,
      infoData: {},
      isDoneBtnLoding: false,
      bottomData:{
          useCount:"",
          warehouseName:"",
          shelfNumber:""
      }
    };
  },
  mounted() {
  },
  created() {
  },
  methods: {
    init(row) {
      this.infoData = row;
      let API = Baseurl + "inventoryController/getInventoryBatchsByBatchOperateId";
      ajaxPost(API,{id:row.id}).then(res=>{
          if(res.data.code==200){
        //    console.log(res.data.data[0])
              if(res.data.data[0]==undefined){
                 
                    this.bottomData.useCount = row.useCount;
                    this.bottomData.warehouseName = row.warehouseName;
                    this.bottomData.shelfNumber = row.shelfNumber;
              }else{
                  console.log(11)
                  this.bottomData.useCount = res.data.data[0].useCount;
                  this.bottomData.warehouseName = res.data.data[0].warehouseName;
                  this.bottomData.shelfNumber = res.data.data[0].shelfNumber;
              }
          }
          
        //   console.log(res.data.data[0]==null)
      })
      
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.isDoneBtnLoding = false;
    },
    confirmOutWarehouse() {
      this.isDoneBtnLoding = true;
      const paramsData = {
        inventoryBatchNo:this.infoData.inventoryBatchNo,
        id: this.infoData.id,
        operateType: this.infoData.operateType,
      };
      this.$emit("confirm", paramsData);
    },
    BarCode(){
        const API = Baseurl + "inventoryPdfPrintController/pdfPrint";
        const paramsData = { id:this.infoData.id};
        ajaxPost(API, paramsData).then(res => {
            window.open(res.data.data, '_blank');
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-container {
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.inform {
  line-height: 30px;

  &.flex {
    display: flex;

    .title {
      flex-shrink: 0;
      font-weight: bold;
    }
  }
}

.channel-flex {
  display: flex;
  margin-right: 20px;
}
</style>